import { ERROR_MESSAGE } from '../constants';
import styles from '../styles.module.css';
import errorIcon from './../../../assets/img/error-cross.svg';

export const ErrorBox = () => {
  return (
    <div className={styles.errorBox}>
      <div className={styles.errorIcon}>
        <img src={errorIcon} alt="Icon" width="16" height="16" />
      </div>
      <div className={styles.message}>{ERROR_MESSAGE}</div>
    </div>
  );
};
